var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M213.332 512c-44.094 0-80-35.883-80-80 0-8.832 7.168-16 16-16s16 7.168 16 16c0 26.477 21.547 48 48 48s48-21.523 48-48c0-8.832 7.168-16 16-16s16 7.168 16 16c0 44.117-35.902 80-80 80zm0 0",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.332 448h-352C16.746 448 0 431.254 0 410.668a37.314 37.314 0 0 1 13.055-28.375c.535-.469 1.11-.895 1.707-1.281C46.078 353.684 64 314.367 64 272.852v-59.52C64 130.988 131.008 64 213.332 64c3.414 0 7.105.062 10.52.64 8.722 1.45 14.613 9.708 13.16 18.41-1.45 8.704-9.856 14.595-18.41 13.141-1.707-.277-3.582-.191-5.27-.191C148.652 96 96 148.629 96 213.332v59.52c0 51.543-22.594 100.312-61.93 133.78-.32.259-.597.493-.941.727A5.28 5.28 0 0 0 32 410.668c0 2.898 2.434 5.332 5.332 5.332h352c2.902 0 5.336-2.434 5.336-5.332 0-1.496-.555-2.582-1.152-3.309-.32-.234-.598-.468-.918-.726-39.36-33.492-61.93-82.238-61.93-133.781v-23.25c0-8.832 7.168-16 16-16s16 7.168 16 16v23.25c0 41.539 17.941 80.875 49.3 108.226.575.383 1.13.79 1.641 1.238a37.22 37.22 0 0 1 13.059 28.352c0 20.586-16.746 37.332-37.336 37.332zm0 0",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.344 106.668c0 58.91-47.754 106.664-106.668 106.664-58.91 0-106.664-47.754-106.664-106.664C256.012 47.758 303.766 0 362.676 0c58.914 0 106.668 47.758 106.668 106.668zm0 0",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellActiveIcon);
export default __webpack_public_path__ + "static/media/bell-active-icon.cf0653d662d79dfbd077677533902189.svg";
export { ForwardRef as ReactComponent };